import {globalStores as stores, globalStores, ui} from '@stores'
import {authStore} from '@utils'
import axios, {AxiosInstance} from 'axios'
import {action, computed, observable} from 'mobx'

export type CloudConfigES = {
  s3?: string
  bucket: string,
  cloudfront: string,
  env?: string
  importImageApiGatewayUrl: string
}

export class AWSStore {
  @observable cloudConfig : CloudConfigES = null

  get es() { return globalStores.es}

  @action loadAWSConfig = async () => {
    const {es} = this
    if (authStore.userIsAuthenticated && es.axiosInstance && es.axiosServicesInstance) {
      // Authenticated User gets full deployment config, unknown non-user gets surface level config (login page URL, default login, company contacts, etc)

      authStore.userIsAuthenticated && await authStore.verifyTokenNotExpired()

      try {
        const r = await es.get<CloudConfigES>({index: es.indexes.vipAWSConfig, id: 'default'})

        this.cloudConfig = r
        return r
      } catch (err) {
        console.log(`No AWS cloud setup for this deployment - performance will be significantly slower than a hosted solution.`)
      }
    }
  }

  @computed get useCloudFront() {
    return this.cloudConfig?.cloudfront != null && (!ui.settings.imageSource || ui.settings.imageSource === 'cloudfront')
  }

  // @computed get cloudConfig() {
  //   const {deployments: {selectedDeployment, deploymentConfig}, nav: {location}} = globalStores
  //   if (!deploymentConfig) return null
  //
  //   if (deploymentConfig?.cloud) {
  //     // Dev mode, we're on localhost
  //     if (selectedDeployment) {
  //       const {url} = selectedDeployment,
  //         hostname = url.match(/\/\/(.*?\.centricsoftware\.com)/)[1]
  //
  //       if (!hostname) {
  //         console.warn(`Unable `)
  //         return null
  //       }
  //       return deploymentConfig.cloud[hostname]
  //     }
  //     else {
  //       return deploymentConfig.cloud[window.location.hostname]
  //     }
  //   }
  //
  //   return null
  // }

  @computed get importImageApiGatewayUrl() {
    const {cloudConfig} = this

    if(!DEBUG || !cloudConfig?.importImageApiGatewayUrl) {
      return ''
    }

    return `https://${cloudConfig.importImageApiGatewayUrl}`
  }

  @computed get baseCloudfrontUrl() {
    const {cloudConfig} = this

    return !cloudConfig?.cloudfront ? null : `https://${cloudConfig.cloudfront}`
  }

  imageUrlFor = (imageName: string, useS3: boolean = false) => {
    return `${useS3 ? this.baseS3Url : this.baseCloudfrontUrl}/assets/images/${_.trimStart(imageName, '/')}`
  }

  fontUrlFor = (font: string) => {
    const {baseCloudfrontUrl, cloudConfig} = this
    if (!cloudConfig?.cloudfront) {
      return `/fonts/${_.trimStart(font, '/')}`
    }

    return baseCloudfrontUrl ? `${baseCloudfrontUrl}/assets/fonts/${_.trimStart(font, '/')}` : `/fonts/${_.trimStart(font, '/')}`
  }

  imageUrlForC8Image = ({extension = 'png', filename, id, isBackgroundImage}: {extension: string; filename: string; id: any, isBackgroundImage?: boolean}) => {
    /** {@see importCustomerImages in copyAssetsToS3.ts to see why ID replacement - example url from RH:  https://d1fgqul5167u7m.cloudfront.net/assets/images/c8/C28911_Modern_Bedroom_Low_Headboard_Platform_Bed_With_Footboard.png%7CImage/!400,400.png} */

    const url = `/c8/${id.replace(/[\/\|]/g, '-')}/${filename}.${extension}`

    return this.imageUrlFor(url, isBackgroundImage)
  }

  urlFor = (path: string) => {
    return `${this.baseCloudfrontUrl}/${_.trimStart(path)}`
  }

  @computed get baseS3Url() {
    const {cloudConfig} = this
    if (!cloudConfig) return ''

    return `https://${cloudConfig?.s3}`
  }

  s3UrlFor = (path: string) => {
    return `${this.baseS3Url}/${_.trimStart(path)}`
  }

  @computed get s3Client() {
    const {baseS3Url} = this

    return baseS3Url ? axios.create({
      baseURL: baseS3Url
    }) : null
  }

  @computed get cfClient() {
    const {baseCloudfrontUrl} = this

    return baseCloudfrontUrl ? axios.create({
      baseURL: baseCloudfrontUrl
    }) : null
  }
}

export const aws = new AWSStore()


// WEBPACK FOOTER //
// ./src/stores/aws/AWSStore.ts